import { History } from 'history';
import { iocNames } from '../iocNames';
import { useInject } from './useInject';

export function useHistory() {
  return useInject<History<unknown>>(iocNames.history);
}
